import { Link } from '@tanstack/react-router';
import type { SportFilter } from '../../api/keys';
import toggle from '../../components/ToggleTabs.module.css';
import { SPORT_META } from '../../lib/sports';
import { SPORT_COLORS } from '../../theme/tokens';
import { SlidingIndicator } from '../../ui/SlidingIndicator';
import { sportSearch, SPORT_FILTERS } from './activitiesModel';
import styles from './activities.module.css';

function FilterLabel({ filter }: { filter: SportFilter }) {
  if (filter === 'all') return <>ALL</>;
  return (
    <>
      <span data-part="swatch" className={styles.swatch} style={{ background: SPORT_COLORS[filter] }} aria-hidden="true" />
      {SPORT_META[filter].label}
    </>
  );
}

const LABELS = SPORT_FILTERS.map((filter) => <FilterLabel key={filter} filter={filter} />);

export function SportFilterTabs({ sport }: { sport: SportFilter }) {
  return (
    <div className={styles.filtersScroll}>
      <nav className={`${toggle.group} ${styles.filters}`} aria-label="Sport filter">
        <SlidingIndicator variant="fill" labels={LABELS} labelClassName={styles.filter} />
        {/* Exact: ALL's empty search is a subset of every search, so Link would mark it current too. */}
        {SPORT_FILTERS.map((filter, i) => (
          <Link key={filter} to="/activities" search={sportSearch(filter)} className={styles.filter} activeOptions={{ exact: true }} aria-current={filter === sport ? 'page' : undefined}>
            {LABELS[i]}
          </Link>
        ))}
      </nav>
    </div>
  );
}
